import React, { useState, useEffect } from 'react';
import { saveToLocalStorage, getFromLocalStorage } from './util';
import { v4 as uuidv4 } from 'uuid';
import CombinationTable from './combinationTable';

import {
  Container,
  AddQuestionBox,
  Section,
  QuestionListSection,
  CreateCombinationSection,
  CombinationListSection,
  Title,
  Input,
  QuestionsList,
  QuestionsListItem,
  ButtonLink,
  Button,
  List,
  ListItem,
  OptionList,
  CreateCombinationOptionList,
  CreateCombinationOptionListItem,
  CombinationOptionList,
  HighlightedOption,
  AddButtonContainer,
  GridBox,
  Strong,
  SVGButtonWrapper
} from './css';
import CloseSVG from './fullyManaged/managedITServices/assets/svg/close';

const GroupForm = () => {
  const [allQuestions, setAllQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState({
    id: uuidv4(),
    question: '',
    options: [{ text: '' }]
  });
  const [combinations, setCombinations] = useState([]);
  const [monthlyPrice, setMonthlyPrice] = useState('');
  const [dueNowPrice, setDueNowPrice] = useState('');
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  useEffect(() => {
    const existingGroups = getFromLocalStorage('groups') || [];
    setCombinations(existingGroups);
    const savedQuestions = getFromLocalStorage('questions_combination') || [];
    setAllQuestions(savedQuestions);
  }, []);

  const handleCurrentQuestionChange = value => {
    setCurrentQuestion({ ...currentQuestion, question: value });
  };

  const handleCurrentOptionChange = (index, value) => {
    const newOptions = [...currentQuestion.options];
    newOptions[index].text = value;
    setCurrentQuestion({ ...currentQuestion, options: newOptions });
  };

  const handleAddCurrentOption = () => {
    setCurrentQuestion({
      ...currentQuestion,
      options: [...currentQuestion.options, { text: '' }]
    });
  };

  const handleSaveCurrentQuestion = () => {
    const newQuestions = [...allQuestions, currentQuestion];
    setAllQuestions(newQuestions);
    saveToLocalStorage('questions_combination', newQuestions);
    setCurrentQuestion({ id: uuidv4(), question: '', options: [{ text: '' }] });
  };

  const handleAddCombination = () => {
    const newCombination = {
      id: Math.random()
        .toString(36)
        .substring(2, 9),
      questions: JSON.parse(JSON.stringify(selectedQuestions)),
      monthlyPrice,
      dueNowPrice
    };

    const newCombinations = [...combinations, newCombination];
    setCombinations(newCombinations);
    saveToLocalStorage('groups', newCombinations);

    setSelectedQuestions([]);
    setMonthlyPrice('');
    setDueNowPrice('');
  };

  const handleAddToCombination = question => {
    if (!selectedQuestions.some(q => q.question === question.question)) {
      // setSelectedQuestions([
      //   ...selectedQuestions,
      //   { ...question, selectedOption: null }
      // ]);
      setSelectedQuestions([...selectedQuestions, { ...question }]);
    }
  };

  const handleRemoveFromCombination = question => {
    setSelectedQuestions(
      selectedQuestions.filter(q => q.question !== question.question)
    );
  };

  const handleOptionSelect = (qIndex, optIndex) => {
    const newCombination = [...selectedQuestions];
    newCombination[qIndex].selectedOption = optIndex;
    setSelectedQuestions(newCombination);
  };

  return (
    <Container>
      <Section>
        <AddQuestionBox>
          <Title>Add Questions</Title>
          <Input
            type="text"
            value={currentQuestion.question}
            onChange={e => handleCurrentQuestionChange(e.target.value)}
            placeholder="Question"
          />
          {currentQuestion.options.map((option, oIndex) => (
            <GridBox key={oIndex}>
              <Input
                type="text"
                value={option.text}
                onChange={e =>
                  handleCurrentOptionChange(oIndex, e.target.value)
                }
                placeholder="Option"
              />
              <Input
                type="number"
                value={option.monthlyPrice}
                onChange={e =>
                  handleOptionChange(index, 'monthlyPrice', e.target.value)
                }
                placeholder="Monthly Price"
              />
              <Input
                type="number"
                value={option.dueNowPrice}
                onChange={e =>
                  handleOptionChange(index, 'dueNowPrice', e.target.value)
                }
                placeholder="Due Now Price"
              />
            </GridBox>
          ))}
          <AddButtonContainer>
            <ButtonLink onClick={handleAddCurrentOption}>
              + Add Option
            </ButtonLink>
          </AddButtonContainer>
          <AddButtonContainer>
            <Button onClick={handleSaveCurrentQuestion}>Save Question</Button>
          </AddButtonContainer>
        </AddQuestionBox>
      </Section>
      <QuestionListSection>
        <Title>Questions</Title>
        <QuestionsList>
          {allQuestions.map((question, qIndex) => (
            <QuestionsListItem key={qIndex}>
              <Strong>Q: {question.question}</Strong>
              <OptionList>
                {question.options.map((option, optIndex) => (
                  <li key={optIndex}>
                    {option.text}{' '}
                    <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                      (monthly: $0, one-time: $0)
                    </span>
                  </li>
                ))}
              </OptionList>
              {/* <hr />
              <div style={{ display: 'flex', gap: '2rem' }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center'
                  }}
                >
                  <span
                    style={{
                      color: '#6c757d',
                      fontSize: '12px',
                      fontWeight: 700
                    }}
                  >
                    Monthly:
                  </span>
                  <span
                    style={{
                      color: '#343a40',
                      fontSize: '16px',
                      fontWeight: 800
                    }}
                  >
                    $0
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center'
                  }}
                >
                  <span
                    style={{
                      color: '#6c757d',
                      fontSize: '12px',
                      fontWeight: 700
                    }}
                  >
                    One Time:
                  </span>
                  <span
                    style={{
                      color: '#343a40',
                      fontSize: '16px',
                      fontWeight: 800
                    }}
                  >
                    $0
                  </span>
                </div>
              </div> */}
              <hr />
              <AddButtonContainer>
                <ButtonLink onClick={() => handleAddToCombination(question)}>
                  + Add to Combination
                </ButtonLink>
              </AddButtonContainer>
            </QuestionsListItem>
          ))}
        </QuestionsList>
      </QuestionListSection>
      <CombinationTable
        selectedQuestions={selectedQuestions}
        setSelectedQuestions={setSelectedQuestions}
      />

      {/* {selectedQuestions.length > 0 && (
        <CreateCombinationSection>
          <Title>Create Combination</Title>
          {selectedQuestions.map((question, qIndex) => (
            <CreateCombinationQuestionBox key={qIndex}>
              <Strong>{question.question}</Strong>
              <CreateCombinationOptionList>
                {question.options.map((option, optIndex) => (
                  <CreateCombinationOptionListItem key={optIndex}>
                    <input
                      type="radio"
                      name={`combination-${qIndex}`}
                      onChange={() => handleOptionSelect(qIndex, optIndex)}
                      checked={question.selectedOption === optIndex}
                    />
                    <label>{option.text}</label>
                  </CreateCombinationOptionListItem>
                ))}
              </CreateCombinationOptionList>
              <AddButtonContainer>
                <ButtonLink
                  onClick={() => handleRemoveFromCombination(question)}
                >
                  - Remove
                </ButtonLink>
              </AddButtonContainer>
            </CreateCombinationQuestionBox>
          ))}
          <div style={{ width: '30%', display: 'flex', gap: '1rem' }}>
            <Input
              type="number"
              value={monthlyPrice}
              onChange={e => setMonthlyPrice(e.target.value)}
              placeholder="Monthly Price"
            />
            <Input
              type="number"
              value={dueNowPrice}
              onChange={e => setDueNowPrice(e.target.value)}
              placeholder="Due Now Price"
            />
          </div>
          <AddButtonContainer>
            <Button onClick={handleAddCombination}>Add Combination</Button>
          </AddButtonContainer>
        </CreateCombinationSection>
      )}

      <CombinationListSection>
        <Title>Combination List</Title>
        <List>
          {combinations.map((combination, combIndex) => (
            <ListItem key={combination.id}>
              <Strong>Combination #{combIndex + 1}</Strong>
              <CombinationQuestions>
                {combination.questions.map((q, qIndex) => (
                  <CombinationQuestionBox key={qIndex}>
                    <Strong>Q: {q.question}</Strong>
                    <CombinationOptionList>
                      {q.options
                        .filter(
                          (option, optIndex) => optIndex === q.selectedOption
                        )
                        .map((option, optIndex) => (
                          <li key={optIndex}>{option.text}</li>
                        ))}
                    </CombinationOptionList>
                  </CombinationQuestionBox>
                ))}
              </CombinationQuestions>
              <hr />
              <PriceContainerMain>
                <PriceContainer>
                  <PriceLabel>Monthly Price:</PriceLabel>
                  <PriceValue>${combination.monthlyPrice}</PriceValue>
                </PriceContainer>
                <PriceContainer>
                  <PriceLabel>Due Now Price:</PriceLabel>
                  <PriceValue>${combination.dueNowPrice}</PriceValue>
                </PriceContainer>
              </PriceContainerMain>
            </ListItem>
          ))}
        </List>
      </CombinationListSection> */}
    </Container>
  );
};

export default GroupForm;
